interface Props {
  /** Rendered height in px; width is derived from the glyph's aspect ratio. */
  readonly size?: number;
}

const TEAL = '#1ab8c9';

/**
 * Dime Terminal brand mark: a "D" with a teal accent square at the stem
 * notch, on a transparent background. Vector reproduction of the brand logo
 * (geometry from the Dime "D" glyph) so it stays crisp at any size and blends
 * into the chrome without a baked background. The "D" inherits `currentColor`
 * (the terminal root sets it from --text-primary) so it tracks the host theme
 * instead of assuming a dark background.
 */
export default function DimeLogo({ size = 24 }: Props) {
  const width = (size * 190) / 261;
  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 190 261"
      fill="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M41.0506505,111.964231 L0.911600546,111.964231 L0.911600546,22.9522592 L41.0506505,22.9522592 L41.0506505,0.619962079 L80.86915,0.619962079 L80.8703736,23.0634943 C141.341034,24.3710084 189.977473,72.5731155 189.977473,131.87348 C189.977473,161.949655 177.486387,189.151555 157.275751,208.827004 C137.617832,227.993193 110.685566,240.038965 80.8696218,240.683482 L80.86915,260.619962 L41.0506505,260.619962 L41.0506505,240.744804 L0.911600546,240.744804 L0.911600546,151.732833 L41.0506505,151.732833 L41.0506505,111.964231 L80.86915,111.964231 L80.86915,151.78273 L41.0506505,151.78273 L41.05,200.648 L78.3478972,200.648655 C117.310357,200.648655 148.887577,169.861319 148.887577,131.87348 C148.887577,112.879561 140.985674,95.6931754 128.221062,83.2478617 C115.456449,70.8025479 97.8291272,63.0983061 78.3478972,63.0983061 L41.05,63.098 L41.0506505,111.964231 Z"
      />
      <rect
        fill={TEAL}
        x="41.0506505"
        y="111.964231"
        width="39.8184995"
        height="39.818499"
      />
    </svg>
  );
}
